/**
 * 电池工具函数
 * 提供电池电量相关的计算和处理函数
 */

/**
 * 根据电量百分比计算电量格数
 * @param {number|string} percent - 电池电量百分比(0-100)
 * @returns {number} - 返回电量格数(0-4)
 */
export function calculateBatteryBars(percent) {
  // percent 确保在0-100
  percent < 0 && (percent = 0);
  percent > 100 && (percent = 100);
  // 确保转换为数字类型
  const numPercent = Number(percent) || 0;
  
  if (numPercent <= 0) {
    return 0;
  } else {
    // 向上取整，电量格数范围 0-4 格
    return Math.ceil(numPercent / 25);
  }
}

/**
 * 判断电量是否处于低电量状态
 * @param {number|string} percent - 电池电量百分比(0-100)
 * @param {number} threshold - 低电量阈值，默认为20
 * @returns {boolean} - 是否为低电量
 */
export function isLowBattery(percent, threshold = 20) {
  const numPercent = Number(percent) || 0;
  return numPercent <= threshold && numPercent > 0;
}

/**
 * 格式化电量显示值
 * @param {number|string} percent - 电池电量百分比
 * @param {boolean} showPercentSign - 是否显示百分比符号
 * @returns {string} - 格式化后的电量显示值
 */
export function formatBatteryDisplay(percent, showPercentSign = false) {
  if (percent === null || percent === undefined || percent === -1) {
    return '--';
  }
  percent > 100 && (percent = 100);
  percent < 0 && (percent = 0);
  const numPercent = Number(percent) || 0;
  return showPercentSign ? `${numPercent}%` : `${numPercent}`;
}